<template>
  <div class="planes-list">
    <h5 class="titulo-listado">
      <font-awesome-icon :icon="['fas', 'leaf']" class="me-2 text-success" />
      Planes de Cultivo
    </h5>

    <div class="listado-wrapper">
      <div
        v-for="plan in planes"
        :key="plan.id"
        class="card-plan"
        :class="{ seleccionado: plan.id === planSeleccionadoId }"
        @click="seleccionarPlan(plan)"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h6 class="mb-1 text-truncate">{{ plan.objetivo || 'Sin objetivo' }}</h6>
            <p class="mb-0 small text-muted">
              Planificado por: <strong>{{ plan.planificado_por || '—' }}</strong>
            </p>
          </div>
          <div>
            <font-awesome-icon icon="chevron-right" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    planes: {
      type: Array,
      required: true,
    },
    planSeleccionadoId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    seleccionarPlan(plan) {
      this.$emit('seleccionar-plan', plan);
    },
  },
};
</script>

<style scoped>
.planes-list {
  max-width: 800px;
  margin: auto;
}

.titulo-listado {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #333;
  display: flex;
  align-items: center;
}

.listado-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.card-plan {
  background-color: #ffffff;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}

.card-plan:hover {
  background-color: #f8f9fa;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.card-plan.seleccionado {
  background-color: #d1ecf1;
  border-color: #0c5460;
  color: #0c5460;
}

.card-plan h6 {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}
</style>
